export enum ActivationBlockReason {
  Used = 'used',
  Invalid = 'invalid',
  Unexpected = 'unexpected',
}

export enum CompanyActivationTokenStatus {
  Pending = 'PENDING',
  Used = 'USED',
  Cancelled = 'CANCELLED',
}

export interface CompanyActivationBillingClient {
  address: string;
  addressComplement: string;
  addressNumber: string;
  city: string;
  cityId: number;
  cnpj: string;
  companyName: string;
  district: string;
  email: string;
  fantasyName: string;
  financialEmail: string;
  id: number;
  mobile: string;
  name: string;
  sellers: Record<string, unknown>[];
  state: string;
  zipcode: string;
}

export interface CompanyActivationBillingModule {
  id: number;
  name: string;
}

export interface CompanyActivationBillingRequest {
  addendumDate: string;
  addendumModule: string;
  addendumValue: number;
  additionalServiceDescription: string;
  additionalServicePrice: number;
  client: CompanyActivationBillingClient;
  createdAt: string;
  createdByUsername: string;
  hasConversion: boolean;
  hasDigitalCertificate: boolean;
  id: number;
  maintenanceDate: string;
  module: CompanyActivationBillingModule;
  months: number;
  notes: string;
  numberOfUsers: number;
  partnerOrigin: string;
  paymentMethod: string;
  referralProgram: boolean;
  sintegraAccess: boolean;
  totalValue: number;
  trainingHours: number;
  unitValue: number;
  updatedAt: string;
}

export interface CompanyActivationTokenValidateResponse {
  billingRequest: CompanyActivationBillingRequest;
  isValid: boolean;
  reason: string;
  status: CompanyActivationTokenStatus;
}

export interface CompanyActivationFormValues {
  login: string;
  password: string;
  passwordVerify: string;
}

export interface CompanyActivationRequest {
  user: CompanyActivationFormValues;
}

export interface CompanyActivationVerifyRequest {
  user: {
    login: string;
  };
}

export interface CompanyActivationVerifyResponse {
  isValid: boolean;
  reason: string;
}

export interface CompanyActivationMatrixSettings {
  applyToProfitMargin: boolean;
  canViewMultipleCompaniesStockInDirectSale: boolean;
  chartsOfAccountsPattern: string;
  defaultPartApplication: boolean;
  defaultPartCode: string;
  generateInvoiceDifferentCompanies: boolean;
  id: number;
  isChatSupportEnabled: boolean;
  isDamageSelectedFirst: boolean;
  isRegisteredInPlugStorage: boolean;
  localizaCupom: string;
  localizaPartner: boolean;
  michelinIntegration: boolean;
  michelinSupplierId: number;
  passwordExpirationDays: number;
  planAccountRegex: string;
  productPriceChangeOnPurchase: string;
  purchaseUseWorkOrderCost: boolean;
  shouldUpdateIbsCbsIsOnExternalImport: boolean;
  shouldUpdateKmOnVehicle: boolean;
  shouldUpdateOriginOnPurchaseAuthorization: boolean;
  shouldUpdatePisCofinsIpiOnExternalImport: boolean;
  shouldUpdateWorkOrderPartManufacturerAfterPurchase: boolean;
  updateNcmAttributesOnExternalImports: boolean;
  vehicleKmIsRequired: boolean;
}

export interface CompanyActivationResponse {
  active: boolean;
  baseType: string;
  blocked: boolean;
  creation: string;
  expiration: string;
  firstTrainingDate: string;
  id: number;
  isFreemiumOrigin: boolean;
  isMultiCompany: boolean;
  ismResponsibleUserId: number;
  matrixSettings: CompanyActivationMatrixSettings;
  maxCompanies: number;
  monthlyFee: number;
  partnerOrigin: string;
  sellerId: number;
}
